import axios from 'axios'
import qs from 'qs'

export const trackerService = ({
  listActivityByUserId (token, userId) {
    return axios.get('/api/AdminActivity/ListByUserId?userId=' + userId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  /*
  {
  "UserId": "00000000-0000-0000-0000-000000000000",
  "StartTS": "2018-02-09T09:04:35.614Z",
  "EndTS": "2018-02-09T09:04:35.614Z"
  } */
  listActivityByDate (token, paramObj) {
    var stringifiedObj = qs.stringify(paramObj)
    return axios.post('/api/AdminActivity/ListActivityByDate', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  /*
  {
  "ActivityId": "00000000-0000-0000-0000-000000000000",
  "UserId": "00000000-0000-0000-0000-000000000000",
  "ActivityData": "string",
  "ActivityType": 0,
  "AdminAction": 0,
  "ScreenName": "string",
  "UserRole": 0,
  "IsPrivate": true
  }
  */
  logActivity (token, activityObj) {
    var stringifiedObj = JSON.stringify(activityObj)
    //  qs.stringify(activityObj)
    return axios.put('/api/AdminActivity/LogActivity', stringifiedObj, {
      'headers': {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/server-util/tracker-service.js